import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import { SearchPanelContainer } from '@components/Search'
import { DatePickerRange } from '@components/DatePicker'
import FilterGroup from '@components/FilterGroup'
import { Autocomplete } from '@components/Autocomplete'
import OptionGroup, { CheckboxOption } from '@components/OptionGroup'

class FinancialRevenueFilterPanel extends Component {
  static propTypes = {
    financialRevenueStore: PropTypes.object,
    staticData: PropTypes.object
  }

  handleParentAccountChange = parentAccount => {
    const { financialRevenueStore } = this.props

    if (parentAccount) {
      financialRevenueStore.parentAccountSuggestion = parentAccount.label
      financialRevenueStore.query.parentAccountId = parentAccount.value
    } else {
      financialRevenueStore.parentAccountSuggestion = ''
      financialRevenueStore.query.parentAccountId = null
    }

    financialRevenueStore.query.page = 1
    financialRevenueStore.filter()
  }

  handleAccountChange = account => {
    const { financialRevenueStore } = this.props

    if (account) {
      financialRevenueStore.accountSuggestion = account.label
      financialRevenueStore.query.accountId = account.value
    } else {
      financialRevenueStore.accountSuggestion = ''
      financialRevenueStore.query.accountId = null
    }

    financialRevenueStore.query.page = 1
    financialRevenueStore.filter()
  }

  handleEntryTypeChange = entryTypes => {
    const { financialRevenueStore } = this.props

    financialRevenueStore.query.entryTypes.replace(entryTypes)
    financialRevenueStore.query.page = 1
    financialRevenueStore.filter()
  }

  handleFromDateChange = date => {
    if (!date) return
    const { financialRevenueStore } = this.props
    financialRevenueStore.query.fromDate = date.toISOString()
    financialRevenueStore.query.page = 1
    financialRevenueStore.filter()
  }

  handleToDateChange = date => {
    if (!date) return
    const { financialRevenueStore } = this.props
    financialRevenueStore.query.toDate = date.toISOString()
    financialRevenueStore.query.page = 1
    financialRevenueStore.filter()
  }

  handleContractTypeChange = selectedItems => {
    const { financialRevenueStore } = this.props

    financialRevenueStore.query.contractTypeIds.replace(selectedItems)
    financialRevenueStore.query.page = 1
    financialRevenueStore.filter()
  }

  onClearSearch = () => {
    this.props.financialRevenueStore.clearSearch()
  }

  render () {
    const { financialRevenueStore } = this.props
    const {
      query,
      entryTypes,
      parentAccountSuggestion,
      accountSuggestion
    } = financialRevenueStore
    const { staticData } = this.props
    const contractTypeOptions = staticData.contractTypes
      .map(type => type.id)
      .concat(0)

    // 0 is added to the list of contract type options to represent
    // the 'No contract' option

    return (
      <SearchPanelContainer
        extrathin
        searchTitle='Filter'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup label='Date range'>
          <DatePickerRange
            onFromChange={this.handleFromDateChange}
            onToChange={this.handleToDateChange}
            fromDate={query.fromDate}
            toDate={query.toDate}
          />
        </FilterGroup>
        <FilterGroup label='Parent account'>
          <Autocomplete
            value={parentAccountSuggestion}
            itemToString={item => item && item.label}
            onChange={this.handleParentAccountChange}
            loadOptions={financialRevenueStore.autocompleteParentAccount}
          />
        </FilterGroup>
        <FilterGroup label='Account'>
          <Autocomplete
            value={accountSuggestion}
            itemToString={item => item && item.label}
            onChange={this.handleAccountChange}
            loadOptions={financialRevenueStore.autocompleteAccount}
          />
        </FilterGroup>
        <FilterGroup label='Contract type'>
          <OptionGroup
            noStyle
            className='entry-types'
            items={contractTypeOptions}
            itemToString={item =>
              (item && staticData.names.contractTypes[item]) || 'No contract'
            }
            selectedItems={query.contractTypeIds.slice()}
            renderItem={CheckboxOption}
            onChange={this.handleContractTypeChange}
          />
        </FilterGroup>
        <FilterGroup label='Entry types'>
          <OptionGroup
            noStyle
            className='entry-types'
            items={entryTypes.slice()}
            itemToString={item => item && item.label}
            selectedItems={query.entryTypes.slice()}
            renderItem={CheckboxOption}
            onChange={this.handleEntryTypeChange}
          />
        </FilterGroup>
      </SearchPanelContainer>
    )
  }
}

export default inject('financialRevenueStore', 'staticData')(
  observer(FinancialRevenueFilterPanel)
)
